var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h40v40h-40z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#0091ff",
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.846 30.77v3.076h3.077v-3.076h9.23l.002 8.266c-1.94.627-4.008.965-6.155.965-6.933 0-13.042-3.528-16.63-8.886l-.226-.344h10.702zm15.385-28.518c6.4 3.338 10.769 10.032 10.769 17.748 0 7.573-4.209 14.163-10.415 17.558l-.354.189v-10.055h-12.308v-6.154h4.615l-4.615-4.615v-4.615h12.308v-10.055zm-9.231-2.252c1.952 0 3.84.28 5.623.801l.532.164-.001 8.266h-9.23v-3.077h-3.078v10.77l-4.615 4.614h4.615v6.154l-12.313.001c-.988-2.368-1.533-4.967-1.533-7.693 0-11.046 8.954-20 20-20z",
    fill: "#030304"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarren);
export default __webpack_public_path__ + "static/media/warren.4db655edad146ae9bd9e331b2d1c589c.svg";
export { ForwardRef as ReactComponent };